<div class="wizard-container h-100 d-flex justify-content-center">
        <div class="request-sent-container wizard-item justify-content-center">
        <span class="request-sent-title">
            {{'specialOffers.wizard.specialOfferRequested.title' | translate}}
        </span>
        <span class="request-sent-subtitle">
            {{'specialOffers.wizard.specialOfferRequested.subtitle' | translate}}
        </span>
        <request-sent-placeholder class="mt-5"></request-sent-placeholder>
        <span class="request-sent-subtitle">
            <span>{{'specialOffers.wizard.specialOfferRequested.subtitle1' | translate}}</span>
            <span
                class="text-primary fw-bold cursor-pointer"
                (click)="redirectToSpecialOffersList()">
                    {{'specialOffers.wizard.specialOfferRequested.subtitle2' | translate}}
            </span>
            <span>{{'specialOffers.wizard.specialOfferRequested.subtitle3' | translate}}</span>
        </span>
    </div>
</div>
